import authSlice from "./authSlice"

export const authReducers = {
    authSlice
}

